module.exports = __webpack_public_path__ + "static/media/check.ca789fec.svg";